import React, { useState } from "react";

//Importar componenetes a renderizarse.
import HeaderChat from "./HeaderChat.jsx";
import BodyChat from "./BodyChat.jsx";

// Chat: Componente que renderiza el contenido de todo el chat (encabezado y contenido).

const Chat = ({ sessionsChatSelected, chatData, setChatData, setSessionsChatSelected, socketConnected }) => {
    const [loadingChat, setLoadingChat] = useState(false); //Estado para mostrar el cargando chats.

    return (
        <>
            <div className="container-chats__chat">
                <div className="container-chat__chat">

                    {/*------Encabezado del Chat--------*/}
                    <HeaderChat socketConnected={socketConnected} idChat={chatData.IdChat} loadingChat={loadingChat}
                    chatName={chatData.Nombre} operatorAsinged={chatData.Iniciales} setSessionsChatSelected={setSessionsChatSelected} setChatData={setChatData}/>

                    {/*------Cuerpo y Contenido del Chat--------*/}
                    <BodyChat socketConnected={socketConnected} chatData={chatData} setLoadingChat={setLoadingChat}
                    loadingChat={loadingChat} sessionsChatSelected={sessionsChatSelected}
                    />

                </div>
            </div>

        </>
    )
};

export default Chat;